// Mock data for Annisa Wedding

export const companyInfo = {
  name: "Annisa Wedding",
  tagline: "Wujudkan Pernikahan Impian Anda dengan Sentuhan Kemewahan",
  description: "Annisa Wedding hadir sebagai wedding organizer terpercaya di Tasikmalaya yang menghadirkan konsep pernikahan mewah, modern, dan penuh kesan. Dengan pengalaman bertahun-tahun, kami siap mewujudkan momen bahagia Anda menjadi kenangan abadi yang tak terlupakan.",
  address: "Setiamulya, Tamansari, Tasikmalaya Regency, West Java",
  mapsLink: "https://maps.app.goo.gl/Twu9p3VJuwAvbpE4A",
  whatsappLink: "https://wa.me/6285951311360?text=Hallo%20Annisa%20Wedding%20%2C%20Saya%20mau%20konsultasi%20perihal%20Wedding",
  phone: "+62 859-5131-1360",
  email: "info@annisawedding.com",
  logo: "https://nemuftsdmjzkzcygkjpg.supabase.co/storage/v1/object/public/assets-devaq/annisa-logo.png"
};

export const services = [
  {
    id: 1,
    title: "Wedding Organizer",
    description: "Perencanaan pernikahan menyeluruh dari A hingga Z dengan tim profesional yang berpengalaman",
    icon: "Heart"
  },
  {
    id: 2,
    title: "Dekorasi & Styling",
    description: "Dekorasi venue yang memukau dengan konsep luxury, modern minimalist, hingga traditional yang elegan",
    icon: "Sparkles"
  },
  {
    id: 3,
    title: "Catering Premium",
    description: "Menu berkualitas tinggi dengan cita rasa istimewa dan presentasi yang memukau untuk tamu Anda",
    icon: "UtensilsCrossed"
  },
  {
    id: 4,
    title: "Photography & Videography",
    description: "Dokumentasi profesional yang mengabadikan setiap momen berharga pernikahan Anda",
    icon: "Camera"
  },
  {
    id: 5,
    title: "Makeup & Busana",
    description: "Tata rias dan busana pengantin yang mempesona sesuai dengan tema dan konsep yang Anda inginkan",
    icon: "Palette"
  },
  {
    id: 6,
    title: "Entertainment",
    description: "Hiburan berkualitas yang membuat acara pernikahan Anda semakin meriah dan berkesan",
    icon: "Music"
  }
];

export const portfolioCategories = [
  { id: "all", name: "Semua Portfolio" },
  { id: "sunda", name: "Adat Sunda" },
  { id: "jawa", name: "Adat Jawa" },
  { id: "bali", name: "Adat Bali" },
  { id: "modern", name: "Modern Minimalist" },
  { id: "outdoor", name: "Outdoor Garden" }
];

///INI UPDATE KONTEN PORTO
export const portfolioGallery = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1689171605478-fece45fb2b37?w=800&q=80",
    title: "Pengantin Adat Indonesia",
    category: ["sunda", "jawa"],
    alt: "Traditional Indonesian bride with white wedding attire"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1643961517747-c7e7d0fea414?w=800&q=80",
    title: "Pernikahan Adat Tradisional",
    category: ["sunda", "jawa"],
    alt: "Indonesian traditional wedding ceremony"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1643963614048-e612f1647adc?w=800&q=80",
    title: "Pengantin Indonesia Elegan",
    category: ["modern", "indoor"],
    alt: "Elegant Indonesian wedding couple"
  },
  {
    id: 4,
    image: "https://images.unsplash.com/photo-1639019011829-16e63e07dc27?w=800&q=80",
    title: "Busana Pengantin Tradisional",
    category: ["sunda", "jawa"],
    alt: "Traditional Indonesian wedding dress"
  },
  {
    id: 5,
    image: "https://images.unsplash.com/photo-1623991614441-2b124385eb63?w=800&q=80",
    title: "Upacara Sungkeman Jawa",
    category: ["jawa"],
    alt: "Javanese Sungkeman wedding ceremony"
  },
  {
    id: 6,
    image: "https://images.unsplash.com/photo-1623991619299-472ca0f95ef3?w=800&q=80",
    title: "Pengantin Adat Jawa",
    category: ["jawa"],
    alt: "Javanese traditional wedding couple"
  },
  {
    id: 7,
    image: "https://images.unsplash.com/photo-1721747994983-96d23e197487?w=800&q=80",
    title: "Keluarga Kebaya Jawa",
    category: ["jawa", "modern"],
    alt: "Javanese family in traditional kebaya"
  },
  {
    id: 8,
    image: "https://images.unsplash.com/photo-1618870478130-35a86a9b4869?w=800&q=80",
    title: "Pernikahan Adat Bali",
    category: ["bali"],
    alt: "Balinese traditional wedding ceremony"
  },
  {
    id: 9,
    image: "https://images.unsplash.com/photo-1642449130285-776aaf432d1c?q=80",
    title: "Kebaya Indonesia Elegan",
    category: ["modern", "sunda"],
    alt: "Elegant Indonesian kebaya"
  },
  {
    id: 10,
    image: "https://images.unsplash.com/photo-1724985975331-64eb105ff20b?w=800&q=80",
    title: "Kebaya Biru Modern",
    category: ["modern"],
    alt: "Modern blue Indonesian kebaya with gold details"
  },
  {
    id: 11,
    image: "https://images.unsplash.com/photo-1515051124667-90dabc5aff59?q=80",
    title: "Pengantin Adat Nusantara",
    category: ["sunda", "jawa", "outdoor"],
    alt: "Traditional Indonesian wedding couple with floral garlands"
  },
  {
    id: 12,
    image: "https://nemuftsdmjzkzcygkjpg.supabase.co/storage/v1/object/public/assets-devaq/outdoor.jpg",
    title: "Deokarsi Outdoor",
    category: ["sunda", "jawa", "outdoor"],
    alt: "Traditional Indonesian wedding couple with floral garlands"
  }  
];

export const testimonials = [
  {
    id: 1,
    name: "Dina & Rizki",
    wedding: "Pernikahan Adat Sunda",
    date: "12 November 2024",
    rating: 5,
    text: "Annisa Wedding benar-benar luar biasa! Dari perencanaan hingga hari H, semuanya berjalan sempurna. Tim yang profesional, dekorasi yang memukau, dan pelayanan yang sangat memuaskan. Terima kasih telah membuat hari pernikahan kami menjadi kenangan terindah!",
    image: "https://images.unsplash.com/photo-1689171605478-fece45fb2b37?w=400&q=80"
  },
  {
    id: 2,
    name: "Siti & Ahmad",
    wedding: "Pernikahan Adat Jawa",
    date: "28 September 2024",
    rating: 5,
    text: "Pelayanan terbaik yang pernah kami dapatkan! Annisa Wedding memahami setiap detail yang kami inginkan. Dekorasi adat Jawa-nya sangat autentik dan elegan. Semua tamu kami terpukau dengan keindahan dekorasi dan kelancaran acara.",
    image: "https://images.unsplash.com/photo-1623991614441-2b124385eb63?w=400&q=80"
  },
  {
    id: 3,
    name: "Putri & David",
    wedding: "Modern Minimalist Wedding",
    date: "15 Agustus 2024",
    rating: 5,
    text: "Kami ingin konsep modern minimalist yang elegan, dan Annisa Wedding mewujudkannya melebihi ekspektasi! Dekorasinya stunning, foto-fotonya cantik, dan yang paling penting, kami bisa enjoy tanpa stress di hari pernikahan. Highly recommended!",
    image: "https://images.unsplash.com/photo-1630930014595-019a27a959b5?w=400&q=80"
  },
  {
    id: 4,
    name: "Rani & Budi",
    wedding: "Outdoor Garden Wedding",
    date: "5 Juli 2024",
    rating: 5,
    text: "Pernikahan outdoor impian kami terwujud berkat Annisa Wedding! Setup garden wedding-nya sangat romantis dan Instagram-able. Tim yang sangat responsif dan helpful. Makanannya juga enak, semua tamu puas. Thank you Annisa Wedding!",
    image: "https://images.unsplash.com/photo-1643963614048-e612f1647adc?w=400&q=80"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Pengalaman Terpercaya",
    description: "Bertahun-tahun menghadirkan pernikahan impian untuk ratusan pasangan dengan kepuasan pelanggan 100%",
    icon: "Award"
  },
  {
    id: 2,
    title: "Desain Eksklusif",
    description: "Konsep dan dekorasi yang unik dan customized sesuai dengan keinginan dan kepribadian Anda",
    icon: "Lightbulb"
  },
  {
    id: 3,
    title: "Vendor Berkualitas",
    description: "Kolaborasi dengan vendor-vendor terbaik dan terpercaya untuk hasil yang maksimal",
    icon: "Users"
  },
  {
    id: 4,
    title: "Harga Kompetitif",
    description: "Paket wedding yang fleksibel dengan harga yang kompetitif dan transparan tanpa biaya tersembunyi",
    icon: "DollarSign"
  }
];

export const heroSlides = [
  {
    id: 1,
    image: "https://images.unsplash.com/photo-1689171605478-fece45fb2b37?w=1920&q=80",
    title: "Ciptakan Momen Pernikahan yang Tak Terlupakan",
    subtitle: "Wedding organizer terpercaya dengan konsep luxury dan modern minimalist"
  },
  {
    id: 2,
    image: "https://images.unsplash.com/photo-1643961517747-c7e7d0fea414?w=1920&q=80",
    title: "Wujudkan Pernikahan Impian Anda",
    subtitle: "Dekorasi memukau, pelayanan prima, kenangan abadi"
  },
  {
    id: 3,
    image: "https://images.unsplash.com/photo-1623991614441-2b124385eb63?w=1920&q=80",
    title: "Dari Perencanaan Hingga Eksekusi Sempurna",
    subtitle: "Tim profesional siap mewujudkan setiap detail pernikahan Anda"
  }
];
